import { Box } from "@mui/material";

import * as React from "react";

export const SSO = () => {
  window?.parent.postMessage(window?.location.href, window?.location.origin);
  return <Box></Box>;
};
